import ErrorWrapperFE from "../form-element/ErrorWrapperFE";
import React, {DetailedHTMLProps, InputHTMLAttributes} from "react";
import {IFormItemElement, IRepeaterFormItemProps, NoneFormItem, RepeaterFormItem} from "../model/FormModel";
import AppButton from "../../../element/button/AppButton";
import {JSX} from "react/jsx-runtime";
import {createChildIndexPointer} from "../helper/PointerHelper";

interface IProps extends IFormItemElement
{
    elementProps?: DetailedHTMLProps<InputHTMLAttributes<HTMLFieldSetElement>, HTMLFieldSetElement>
    formItemProps:IRepeaterFormItemProps;
    rowLines:JSX.Element[];
    incrementalTitle?:string;
}

const RepeaterItemFIE = (props: IProps) =>
{
    let {
        form,
        label,
        instructions,
        formItemProps,
        rowLines,
        incrementalTitle,
        elementProps,
        children,
    } = props;

    const formItem = form.requireFormItem(formItemProps, "repeater", true) as RepeaterFormItem;

    label = label ?? formItem.name;
    label = label || !formItem.required ? label : " ";

    const addRow = () => {
        formItem.addRow();
        form.refreshState();
    }

    const removeRow = (rowID: string) => {
        const index = formItem.currentRowIDs.indexOf(rowID);
        if(index < 0){
            return
        }
        const newOrder:number[] = [];
        for(let i = 0; i < formItem.currentRowIDs.length; i++){
            if(i !== index){
                newOrder.push(i);
            }
        }
        formItem.removeRow(rowID);
        form.applyNewItemGroupArrayOrder(formItem.pointer, newOrder);
        form.refreshState();
    }

    const resetRepeater = () => {
        formItem.currentRowIDs = formItem.value.slice();
        form.applyNewItemGroupArrayOrder(formItem.pointer, []);
        form.refreshState();
    }

    return <div className={form.isFormItemHidden(formItem) ? "d-none" : ""}>
        <ErrorWrapperFE
            formItem={formItem}
        >
            <fieldset
                {...elementProps}
                data-form-item-id={formItem.itemID}
            >
                <div className="row">
                    {!!label &&
                        <div className="col-12">

                            <label
                                className={"form-item-label" + (formItem.required ? " required" : "")}
                            >
                                {label}
                                <input id={formItem.itemID} className="d-none" />
                            </label>
                        </div>
                    }
                    {!!instructions && (
                        <div className="col-12">
                            <span className="instructions">{instructions}</span>
                        </div>
                    )}
                    {!formItem.isFixedAmount() && (
                        <div className="col-12 text-start">


                            <AppButton
                                className="btn primary icon-only reduced ms-1"
                                disabled={!formItem.canAddRow()}
                                onClick={addRow}
                            >
                                <i
                                    className="fa fa-solid fa-plus"
                                    aria-hidden="true"
                                ></i>
                            </AppButton>

                            {!formItem.isFixedAmount() && (
                                <AppButton
                                    className="btn primary icon-only reduced ms-1"
                                    disabled={!formItem.canReset()}
                                    onClick={() => resetRepeater()}
                                >
                                    <i
                                        className="fa fa-solid fa-rotate-left"
                                        aria-hidden="true"
                                    ></i>
                                </AppButton>
                            )}
                        </div>
                    )}
                    {formItem.currentRowIDs.map((rowID, index) =>

                        <div className="col-12 mb-5" key={rowID}>
                            {(() => {
                                const entryPointer = createChildIndexPointer(index, formItem.pointer);

                                const entryFormItem = form.requireFormItem({
                                    pointer: entryPointer,
                                    name: formItem.name + " " + (index + 1),
                                }, "none", true) as NoneFormItem;

                                return <ErrorWrapperFE
                                    formItem={entryFormItem}
                                >
                                    <div className="row">
                                        <div className="col-12">
                                            {incrementalTitle && <legend>{incrementalTitle}  ({index + 1})</legend>}
                                        </div>

                                    </div>
                                    <div className="row">
                                        {!formItem.isFixedAmount() && (
                                            <div className="col-1 text-start">

                                                <AppButton
                                                    className="btn primary icon-only reduced ms-1"
                                                    disabled={!formItem.canRemoveRow()}
                                                    onClick={() => removeRow(rowID)}
                                                >
                                                    <i
                                                        className="fa fa-solid fa-trash"
                                                        aria-hidden="true"
                                                    ></i>
                                                </AppButton>
                                            </div>
                                        )}
                                        <div className={!formItem.isFixedAmount() ? "col-11" : "col-12"}>
                                            <div className="row">
                                                {rowLines[index] ?? <></>}
                                            </div>
                                        </div>
                                    </div>
                                </ErrorWrapperFE>
                            })()}

                        </div>
                    )}
                    {!!children && (
                        <div className="col-12">
                            {children}
                        </div>
                    )}
                </div>
            </fieldset>
        </ErrorWrapperFE>
    </div>;
}

export default RepeaterItemFIE;